import {Injectable} from '@angular/core';
import {InfoService} from '../section-service.class';
import {Service} from '../../common/service.class';
import {Observable} from 'rxjs';
import {Language} from './language.model';

/**
 * Created by Rodrigo Quesada on 12/12/16.
 */
@Injectable()
export class LanguageService extends InfoService {

    constructor(svcm: Service.InjectedMembers) {
        super(svcm, 'language');
    }

    getLanguages(): Observable<Array<Language>> {
        return this.getList(Language);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/model/info/language/language.service.ts